import { render, staticRenderFns } from "./KgjtWebsiteSubsidiaryCompany.vue?vue&type=template&id=b77b089c&scoped=true&"
import script from "./KgjtWebsiteSubsidiaryCompany.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteSubsidiaryCompany.vue?vue&type=script&lang=js&"
import style0 from "./KgjtWebsiteSubsidiaryCompany.vue?vue&type=style&index=0&id=b77b089c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77b089c",
  null
  
)

export default component.exports